import { writable } from 'svelte/store';

let store = writable([]);

export default {
    subscribe: store.subscribe,

    order(count) {
        let form = new FormData();
        form.set('count', count);

        return fetch(`/api/order-credits`, {
            credentials: 'same-origin',
            method: 'POST',
            body: form
        }).then(res => {
            if (!res.ok) throw new Error('Oh no');

            return res.json();
        }).then(res => {
            if (res.status) {
                return res;
            }

            return false;
        }).catch(e => {
            return false;
        });
    }
};